import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import api from "@/lib/api";
import { Layers, ArrowRight } from "lucide-react";

export default function Flashcards() {
  const [decks, setDecks] = useState([]);

  useEffect(() => {
    api.get("/flashcards").then((r) => setDecks(r.data));
  }, []);

  return (
    <PageShell>
      <div className="max-w-7xl mx-auto px-6 py-14">
        <span className="text-xs uppercase tracking-widest font-mono text-primary">Study Tools</span>
        <h1 className="font-serif text-5xl mt-2 mb-3">Flashcards</h1>
        <p className="text-muted-foreground max-w-2xl mb-12">
          Flip through concept and terminology decks. Track how many cards you know as you review.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {decks.map((d) => (
            <Link key={d.slug} to={`/flashcards/${d.slug}`} data-testid={`deck-${d.slug}`} className="bg-card p-7 group hover:bg-muted transition-colors">
              <Layers className="w-7 h-7 text-primary mb-6" />
              <span className="text-[10px] uppercase tracking-widest font-mono text-muted-foreground">{d.category}</span>
              <h2 className="font-serif text-2xl mt-1 leading-tight">{d.title}</h2>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{d.description}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-mono text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                Study deck <ArrowRight className="w-3 h-3" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
